import styled, { css } from 'styled-components';
import { Col, Row as AntRow, Tag, Switch, Avatar as AntdAvatar } from 'antd';
import {
  Form as BaseForm,
  FormItem as FormItemBase,
  Text as OriginalText,
  Button as BaseButton,
} from '@vette/ui-components';
import { Typography as AntdTypography } from 'antd';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 36px;
`;

export const Section = styled.div`
  display: flex;
  flex: 1;
  gap: 12px;
  flex-direction: column;
  margin-bottom: 30px;

  &:nth-child(3) {
    margin-bottom: 18px;
  }
`;

export const Form = styled(BaseForm)`
  display: flex;
  flex: 1;
  height: 100vh;
`;

export const TitleRow = styled(AntRow)`
  margin-bottom: 20px;
`;

export const Row = styled(AntRow)<{
  $marginTop?: number;
}>`
  margin-top: ${({ $marginTop }) => ($marginTop ? $marginTop - 12 : null)}px;
  margin-bottom: 0;
`;

export const StripeCol = styled(Col)`
  padding-right: 18px;
`;

export const StatBadge = styled(Tag)`
  color: ${({ theme }) => theme.colors.white};
  border: none;
  background: ${({ theme }) => theme.colors.green40};
  padding: 1px 8px;
  font-weight: 600;
  margin: 0;
`;

export const FullWidthFormItem = styled(FormItemBase)`
  width: 100%;
`;

export const DisclaimerText = styled(OriginalText)`
  color: ${({ theme }) => theme.colors.grey40};
`;

export const DisclaimerTypography = styled(AntdTypography)`
  text-align: center;
  margin-top: 12px;
`;

export const DisclaimerButton = styled(BaseButton)`
  color: ${({ theme }) => theme.colors.grey40};
  display: inline;
  font-size: inherit;
  height: auto;
  padding: inherit;
  line-height: inherit;
  font-weight: inherit;

  &.ant-btn > span {
    color: ${({ theme }) => theme.colors.grey40};
    text-decoration: underline;
  }
`;

export const NotificationSwitch = styled(Switch)`
  margin-right: 15px;

  &.ant-switch-disabled {
    opacity: 1;
  }
`;

export const AvatarWrapper = styled.div<{ $isEmpty: boolean }>`
  min-width: 403px;
  border: 1px solid ${({ theme }) => theme.colors.grey20};
  border-radius: 18px;
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 12px;
  justify-content: space-between;

  ${({ $isEmpty }) =>
    $isEmpty &&
    css`
      cursor: pointer;
      border-style: dashed;
    `}
`;

export const UploadButton = styled(BaseButton)`
  color: ${({ theme }) => theme.colors.grey100};
  font-size: 12px;
  height: 12px;
  text-decoration: underline !important;
  background: none !important;
  padding: 0;
`;
export const Avatar = styled(AntdAvatar)`
  width: 24px;
  height: 24px;
`;

export const DeleteIcon = styled(DeleteOutlineIcon)`
  color: ${({ theme }) => theme.colors.grey40};
  cursor: pointer;
`;
